<template>
    <layout class="Reporttxt">
      <div>
        <div class="row space-between">
            <pair label="姓名" :value="data.hospital_patient_name" />
            <pair label="年龄" :value="age" />
            <pair label="性别" :value="data.hospital_patient_sex" />
        </div>
        <div class="row space-between">
            <pair label="床号" :value="data.hospital_patient_bedno" />
            <pair label="住院号" :value="data.hospital_patient_homeno" />
        </div>
        <div class="row space-between">
            <pair label="送诊科室" :value="data.hospital_send_department" />
            <pair label="送诊医生" :value="data.hospital_check_doctor" />
        </div>
        <div class="split"></div>
        <div class="title">{{data.Modality || '检查'}}所见:</div>
        <div class="txt" v-html="data.hospital_patient_video || '无'"></div>
        <div class="split"></div>
        <div class="title">{{data.Modality || '意见'}}诊断：</div>
        <div class="txt" v-html="data.hospital_patient_videodesc || '无'"></div>
        <div class="main-btns">
          <div class="orange" @click="checkHistory">报告对比</div>
          <div class="blue" style="margin-left: 10px;" @click="toMovie(is_open_dicom_processing?true:false)">{{is_open_dicom_processing?'查阅电子胶片':'查阅影像'}}</div>
          <div class="green" style="margin-left: 10px;" @click="askAI">AI解读</div>
        </div>

        <div class="row space-between">
            <pair label="报告医生" :value="data.hospital_doctor_name" />
            <pair label="审核医生" :value="data.hospital_check_docname" />
        </div>
        <div class="row space-between">
            <pair label="报告生成时间" :value="data.hospital_generate_time" />
        </div>
        <div class="row space-between"></div>
      </div>
      <template slot="compare">
        <div v-if="showDates" class="dates-compare">
          <div v-if="!showCompare" class="compare-c">
            <div class="compare-title">
              <label>选择要对比的报告</label>
              <div @click="closeDates" class="close"></div>
            </div>
            <div class="dates">
              <div class="date-item" @click="selectOrCancel(item)" v-for="item in historyList" :key="item.hospital_check_time">
                  <span class="hospital">
                    {{item.hospital_name}}
                    <div :class="{selected: item.selected, select: true}"></div>
                  </span>
                <span class="common-item">
                  <span class="item-prop">患者姓名：</span>
                  <span class="item-value">{{item.hospital_patient_name}}</span>
                </span>
                <span class="common-item">
                  <span class="item-prop">检查类型：</span>
                  <span class="item-value">{{item.Modality}}</span>
                </span>
                <span class="common-item">
                  <span class="item-prop">检查部位：</span>
                  <span class="item-value">{{item.hospital_check_place}}</span>
                </span>
                <span class="common-item">
                  <span class="item-prop">检查时间：</span>
                  <span class="item-value">{{item.hospital_check_time}}</span>
                </span>
              </div>
            </div>
            <div class="btn-compare">
              <div class="orange" @click="doCompare">报告对比</div>
            </div>
          </div>
          <div v-if="showCompare" class="compare-c">
            <div class="compare-title">
              <label>报告对比</label>
              <div @click="closeCompare" class="close"></div>
            </div>
            <div class="compare-report">
              <div class="compare-item" v-for="(rdata, index) in compareReports" :key="index">
                <fieldset>
                  <legend class="l-title">{{rdata.hospital_name}} {{rdata.hospital_check_time.substring(0,10)}}</legend>
                  <div class="check-info">
                      <span class="common-item">
                        <span class="item-prop">检查部位：</span>
                        <span class="item-value">{{rdata.hospital_check_place}}</span>
                      </span>
                    <span class="common-item">
                        <span class="item-prop">检查方法：</span>
                        <span class="item-value">{{rdata.hospital_check_direction}}</span>
                    </span>
                  </div>
                  <div class="split"></div>
                  <div class="title">{{rdata.Modality || '检查'}}所见:</div>
                  <div class="txt" v-html="rdata.hospital_patient_video || '无'"></div>
                  <div class="split"></div>
                  <div class="title">{{rdata.Modality || '意见'}}诊断：</div>
                  <div class="txt" v-html="rdata.hospital_patient_videodesc || '无'"></div>
                </fieldset>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template slot="payback">
        <payback v-if="showPay" :pay-item="data" :open-id="openId" @payloading="setPayLoading" @close="closePay"></payback>
      </template>
      <template slot="loading">
        <div class="loading-cover" :style="{display: historyLoading ? 'flex': 'none'}">
          <div class="data-loading-indicator"></div>
<!--          <div class="text">加载中</div>-->
        </div>
      </template>
      <popup v-if="!showPay" :show.sync="showTimeExpired">
        <div v-if="timeExpired===1" class="noelectron-box" :class="{'noelectron-box2': canRestore}">
          <div class="close" @click="showTimeExpired=false">X</div>
          <div class="text">您已打印塑料胶片<br/>电子胶片功能关闭</div>
          <div v-if="canRestore" @click="toPay" class="btn">
            恢复影像
          </div>
        </div>
        <div v-if="timeExpired===2" class="noelectron-box noelectron-box2" v-show="showTimeExpired">
          <div class="text">
            您已打印塑料胶片，电子胶片将在{{expireDay?  expireDay + '天' : ''}}{{expireHour?  expireHour + '小时' : ''}}{{expireMinute?  expireMinute + '分钟' : ''}}后关闭。
          </div>
          <div @click="showTimeExpired=false;toMovie(false, true)" class="btn">
            好的
          </div>
        </div>
      </popup>
      <popup :show.sync="noHistory">
        <div class="noelectron-box" v-show="noHistory">
          <div class="close" @click="noHistory=false">X</div>
          <div class="text">未查询到您的电子胶片历史记录</div>
        </div>
      </popup>
      <popup :show.sync="isDeleteShow">
        <div class="noelectron-box" v-show="isDeleteShow">
          <div class="close" @click="isDeleteShow=false">X</div>
          <div class="text">正在准备数据<br/>请稍后再试</div>
        </div>
      </popup>
      <popup v-if="!showPay" :show.sync="noElectronShow">
        <div v-if="entity_film_print" class="noelectron-box" :class="{'noelectron-box2': canRestore}">
          <div class="close" @click="noElectronShow=false">X</div>
          <div class="text">您已打印塑料胶片<br/>电子胶片功能关闭</div>
          <div v-if="canRestore" @click="toPay" class="btn">
            恢复影像
          </div>
        </div>
        <div v-else class="noelectron-box">
          <div class="close" @click="noElectronShow=false">X</div>
          <div class="text">暂无电子胶片<br/>请查看原始影像</div>
        </div>
      </popup>
      <popup :show.sync="showAIDisclaimer" position="center">
        <div class="popup">
          <div class="disclaimer-box">
            <div class="close" @click="showAIDisclaimer=false">X</div>
            <div class="title">AI辅助报告解读免责声明</div>
            <div class="text">
              请在使用前仔细阅读并确认<br/>
              在使用本AI辅助报告解读服务（以下简称"本服务"）前，请您务必仔细阅读并理解透彻本《免责声明》（以下简称"本声明"）。 
              请您知悉，如果您选择继续使用本服务，意味着您充分知悉并接受以下使用条件：
              1、本服务基于DeepSeek-R1人工智能模型生成解读内容，处于前沿探索阶段，测试体验功能仅供学术目的使用，
              未经许可，请勿分享、传播输入及生成的文本、图片内容。
              本服务生成的内容不代表任何专业医疗诊断意见，仅为辅助性参考信息。
              所有内容均通过算法自动分析生成，可能存在不完整、不准确或滞后性。<br/>
              2、您知悉并同意：<br/>
              由于本解读不构成任何医疗建议，因此请勿将本软件产生的任何解读与医疗行为进行比对，
              如擅自将解读用于与医疗行为比对产生的任何后果由使用人自行负担，本公司不承担任何责任，
              并有权追究使用者的侵权责任。<br/>
              3、因使用本功能导致的直接或间接损失（包括但不限于误诊、延误治疗等），本公司及技术提供方不承担任何法律责任。
              您理解并接受：<br/>
              医学影像数据交由大模型解读可能涉及数据传输及泄露风险；<br/>
              AI模型的训练数据截止至2023年10月，无法覆盖最新医学进展。<br/><br/>

              如您同意上述免责条款，请点击同意按钮，否则请点击不同意按钮。
            </div>
            <div class="btn-group">
              <div class="btn cancel" @click="showAIDisclaimer=false">不同意</div>
              <div class="btn agree" @click="getAISuggestion">同意</div>
            </div>
          </div>
        </div>
      </popup>
      
      <popup :show.sync="showAIResult" position="center">
        <div class="popup-container">
          <div class="ai-result-box">
            <div class="close" @click="showAIResult=false">X</div>
            <div class="title">AI生成结果</div>
            <template>
              <div class="ai-disclaimer">
                本影像报告解读由人工智能（AI）DeepSeek-R1生成，仅作为辅助参考信息，不能替代专业医师的临床判断或诊疗建议，具体病情请以医疗机构出具的正式报告为准并咨询执业医师。
              </div>
              <div class="content" v-html="aiResult"></div>
            </template>
            <div v-if="aiLoading" class="ai-loading">
              <div class="loading-spinner"></div>
              <div class="loading-text">DeepSeek-R1正在深度思考中，一般用时30秒-1分钟以上，请稍候...</div>
            </div>
          </div>
        </div>
      </popup>
    </layout>
</template>

<script>
import layout from '../Report/layout'
import data from '@/views/data'
import popup from '../Report/pupup'
import { dicomRecover,getInformation, getHistory, getAccessKey } from "@/api/api";
import {Toast} from "vant";
import payback from "@/views/Report/payback.vue";
import axios from 'axios';

export default {
    components: {
      payback,
        layout,
        popup,
        pair: {
            props: {
                label: {type: String, default: ''},
                value: {type: [String, Number], default: ''},
            },
            render () {
                return <div class="pair row-margin0">
                    <span class="label">{this.label}</span>
                    <span class="value">{this.value || '无'}</span>
                </div>
            }
        }
    },
    data(){
      return {
        isDeleteShow: false,
        historyLoading: false,
        historyList: [],
        compareReports: [],
        noHistory: false,
        showPay: false,
        showDatesCompare: false,
        showDates: false,
        showCompare: false,
        noElectronShow: false,
        showTimeExpired: false,
        expireDay: 0,
        expireHour: 0,
        expireMinute: 0,
        showAIDisclaimer: false,
        showAIResult: false,
        aiResult: '',
        aiLoading: false,
      }
    },
    methods: {
      setPayLoading(loading) {
        this.payLoading = loading
      },
      toPay() {
        this.showPay=true
        this.showTimeExpired = false
        this.noElectronShow = false
      },
      closePay() {
        this.showPay=false
      },
      closeCompare() {
        this.showCompare = false
        this.showDates = true
      },
      closeDates() {
        this.showDates = false
        this.showCompare = false
      },
      selectOrCancel(item) {
        item.selected = !item.selected
      },
      doCompare() {
        let selected = this.historyList.filter(i => i.selected)
        if (selected.length < 1) {
          Toast('请选择报告')
          return
        }
        this.compareReports = []
        this.compareReports.push({
          ...this.data
        })
        this.compareReports = this.compareReports.concat(selected)
        console.log('compareReports', this.compareReports)
        this.showCompare = true

      },
      checkHistory() {
        this.historyLoading = true
        getHistory({
          AccessionNumber: this.AccessionNumber,
          house_id: this.house_id,
          check_phone_key: this.phone_key,
          key: this.key,
          password: this.password,

        }).then(res => {
          this.historyLoading = false
          // console.warn('res-history', res)
          if (!res || !res.length){
            this. noHistory = true
          }else{
            this.showDates = true
            this.historyList = res.map(i => {
              return {
                ...i,
                selected: false
              }
            })
          }
          // Toast('未查询到您的电子胶片历史记录')
        }).catch(err => {
          this.historyLoading = false
          console.log(err)
        })
      },
      checkDelete(success) {
        if(this.isDeleteDicom) {
          getInformation({
            house_id: this.house_id,
            AccessionNumber: this.AccessionNumber,
            last_phone_key: this.phone,
            page: 'index'
          }).then(res => {
            console.warn('check_is_delete', res)
            if (res.data.is_delete_dicom) {
              console.log("恢复影像1")
              this.isDeleteShow = true
              dicomRecover({
                hospital_id: this.house_id,
                studyIuid: res.data.StudyInstanceUID
              })
            } else {
              success && success()
            }
          })
        } else {
          success && success()
        }
      },
        toMovie(bElectronMovie, noCheck) {
            if(this.entity_film_print){
              this.noElectronShow = true;
              return;
            }
            if(bElectronMovie && !this.data.is_add_dicom_processing){
              this.noElectronShow = true;
              return;
            }
            if (!noCheck && this.timeExpired > 0) {
              this.showTimeExpired = true
              return
            }
            //data.urrl(bElectronMovie?1:0)
            this.checkDelete(() => {
              data.urrl(bElectronMovie?1:0)
            })
        },
      askAI() {
        this.showAIDisclaimer = true;
      },
      
      getAISuggestion() {
        this.showAIDisclaimer = false;
        this.aiLoading = true;
        this.showAIResult = true; // 立即显示结果弹窗，但内容显示为加载中
        
        const url = `https://sys.baijiecloud.com/api/aiSuggestion?AccessionNumber=${this.AccessionNumber}&house_id=${this.house_id}&check_phone_key=${this.phone_key}&page=index`;
        
        axios.get(url)
          .then(response => {
            if (response.data) {
              console.log('response', response)
              // 处理特定格式的响应
              if (response.data.data) {
                let content = response.data.data;
                
                // 直接替换标签，而不是提取内容
                let processedContent = content
                  .replaceAll('<建议>', '')  // 移除开始标签
                  .replaceAll('</建议>', '')  // 移除结束标签
                  .trim();

                
                // 去掉加粗格式 (** 或 __ 格式)
                processedContent = processedContent.replaceAll(/\*\*(.*?)\*\*/g, '$1');
                processedContent = processedContent.replaceAll(/__(.*?)__/g, '$1');

                
                // 将换行符转换为 <br> 标签
                let formattedContent = processedContent
                  .replaceAll('\n', '<br>')
                  .replaceAll(/\u003c/g, '<')  // 替换其他 Unicode 编码的 < 符号
                  .replaceAll(/\u003e/g, '>'); // 替换其他 Unicode 编码的 > 符号

                
                this.aiResult = formattedContent;
              } else {
                this.aiResult = response.data.data || '暂无AI分析结果';
              }
            } else {
              this.aiResult = '获取AI分析失败，请稍后再试';
            }
            this.aiLoading = false;
          })
          .catch(error => {
            console.error('AI分析请求失败:', error);
            this.aiResult = '获取AI分析失败，请稍后再试';
            this.aiLoading = false;
          });
      },
    },
    computed: {
      canRestore() {
        if (this.data && this.data.id==1476667 && this.data.is_delete_dicom===0 && this.data.entity_film_print_time) {
          return true
        }
        return false
      },
        timeExpired() {
          //付费恢复的影像直接看
          if (this.data  && this.data.is_delete_dicom==8) {
            return 0
          }

          //第一中心医院，2023年9月1号之后的，所有MR，不再受是否打印实体胶片限制
          if (this.data.house_id && this.data.house_id.startsWith('dyzx') && this.data.Modality === 'MR' && this.data.hospital_check_time>='2023-09-01') {
            return 0
          }

          if(this.data && this.data.entity_film_print_time && this.data.is_delete_dicom!==9) {
            const diff = 3 * 24 * 60 * 60 * 1000
            const curdiff = new Date().getTime() - new Date(this.data.entity_film_print_time).getTime()
            console.log('curdiff/diff:', curdiff, diff)
            if (curdiff < diff) {
              const n = diff - curdiff
              this.expireDay = Math.floor(n / (24 * 60 * 60 * 1000))
              this.expireHour = Math.floor((n - this.expireDay * 24 * 60 * 60 * 1000) / (60 * 60 * 1000))
              if (this.expireHour===0) {
                this.expireHour = 1
              }
              return 2
            }
            return 1
          }
          return 0
        },
        is_open_dicom_processing () {
          return this.data && this.data.is_open_dicom_processing==1 && this.data.is_delete_dicom!==8 && this.data.is_delete_dicom!==9;
        },
        entity_film_print () {
          return this.data && ((this.data.entity_film_print==1 && this.data.is_delete_dicom!==8 && this.data.is_delete_dicom!==9) || (this.data.is_delete_dicom==1 && this.data.house_id!=='qyzyy' && this.data.house_id!=='qyfy'));
        },
        isDeleteDicom () {
          return !!data.data.is_delete_dicom
        },
        data () {
            return data.data
        },
        date () {
            return this.data.hospital_check_time ? this.data.hospital_check_time.split(' ')[0] : ''
        },
        age () {
            return this.data.hospital_patient_age ? this.data.hospital_patient_age.split(' ')[0] : ''
        },
        AccessionNumber () {
            return data.AccessionNumber
        },
        key () {
            return data.key
        },
        house_id () {
            return data.house_id
        },
        password() {
            return data.password
        },
        openId() {
          return data.open_id
        },
        phone_key() {
          return data.phone_key
        }
    },
    mounted () {
        data.getData()
    }
}
</script>

<style scoped>
/* 添加主按钮容器的样式 */
.main-btns {
  display: flex;
  justify-content: center;
  margin-top: 20px;  /* 增加与上方文字的间距 */
  margin-bottom: 20px;
}

/* 修改按钮样式 */
.main-btns > div {
  flex: 1;
  max-width: 120px;
  padding: 6px 0;
  border-radius: 4px;
  font-size: 14px;
  text-align: center;
  white-space: nowrap;
  margin: 0 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
}

.orange {
  background-color: #ff9800;
  color: white;
}

.blue {
  background-color: #2196F3;
  color: white;
}

.green {
  background-color: #42b983;
  color: white;
}

/* 修改免责条款弹窗样式 */
.disclaimer-box, .ai-result-box {
  width: 80%;
  max-width: 400px; /* 限制最大宽度 */
  background: white;
  border-radius: 8px;
  padding: 20px;
  position: relative;
  margin: 0 auto; /* 水平居中 */
  max-height: 60vh; /* 限制最大高度为屏幕的60% */
  overflow: hidden; /* 防止内容溢出 */
  display: flex;
  flex-direction: column;
}

.disclaimer-box .title, .ai-result-box .title {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 15px;
}

.disclaimer-box .text, .ai-result-box .content {
  margin-bottom: 20px;
  max-height: 40vh; /* 为按钮留出空间 */
  overflow-y: auto; /* 添加垂直滚动条 */
  padding-right: 10px; /* 为滚动条留出空间 */
  font-size: 14px;
  line-height: 1.5;
}

.disclaimer-box .btn-group {
  display: flex;
  justify-content: space-between;
  margin-top: auto; /* 将按钮推到底部 */
}

.disclaimer-box .btn {
  padding: 8px 20px;
  border-radius: 4px;
  text-align: center;
  flex: 1;
  margin: 0 10px;
}

.disclaimer-box .cancel {
  background-color: #f44336; /* 警告色 */
  color: white;
}

.disclaimer-box .agree {
  background-color: #42b983;
  color: white;
}

/* 确保弹窗在屏幕中居中 */
/deep/ .van-popup {
  top: 50% !important;
  transform: translateY(-50%) !important;
  max-height: 80vh !important;
}

/* 或者尝试这种写法 */
/*
>>> .van-popup {
  top: 50% !important;
  transform: translateY(-50%) !important;
  max-height: 80vh !important;
}
*/

.popup-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

/* 修改弹窗容器样式 */
.popup {
  margin-top: 50px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.popup-container {
  margin-top: 50px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  height: 100%;
}

/* 添加AI结果弹窗的样式 */
.ai-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top-color: #42b983;
  animation: spin 1s ease-in-out infinite;
  margin-bottom: 15px;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.loading-text {
  font-size: 16px;
  color: #666;
}

.ai-disclaimer {
  margin-top: 20px;
  padding: 10px;
  background-color: #ffebee;
  border-left: 4px solid #f44336;
  color: #d32f2f;
  font-size: 14px;
  line-height: 1.5;
  font-weight: bold;
}

/* 确保AI结果弹窗内容区域有足够的空间 */
.ai-result-box .content {
  max-height: 50vh;
  overflow-y: auto;
  margin-bottom: 10px;
}
</style>
